<template>
	<div class="viphome">
		<Nav></Nav>
		<HomeNav currentTab="2" :deviceLength="list.length"></HomeNav>
		<div class="viplist-wrap" v-loading="isLoading">
			<div class="viplist">
				<div class="no-service-wrap" v-if="!allServiceCount">
					<div
						class="how-to-use"
						v-if="isShowUse && !$store.getters.isAppstoreMode"
					>
						<div class="close" @click="isShowUse = false"></div>
						<div class="diamond-icon"></div>
						<div class="diamond-wrap">
							<div class="diamond-text">高级功能如何使用？</div>
							<div class="diamond-btn" @click="goClick">
								使用指引
								<div class="diamond-btn-icon"></div>
							</div>
						</div>
					</div>
					<div class="no-service">
						<div class="no-icon"></div>
						<div class="no-text">暂无服务</div>
						<div class="no-text2">
							点击下方”发现服务”或”手动添加”
						</div>
					</div>
					<div class="btns">
						<div class="btn" @click="goDiyClick">手动添加</div>
						<div class="btn btn2" @click="findClick">发现服务</div>
					</div>
				</div>
				<div class="service-wrap">
					<div
						class="about-vip"
						v-if="$store.state.user.vip_left == 0"
						@click="goVipClick"
					>
						<div class="vip-icon"></div>
						<div class="vip-icon2"></div>
						<div class="vip-text">访问次数不限</div>
						<div class="vip-btn">立即开通</div>
					</div>
					<div
						class="try-times"
						v-if="$store.state.user.vip_left == 0"
					>
						<!--							<div class="line"></div>-->
						<div class="try-text">
							剩余体验次数
							<div class="try-count">{{ leftTimes }}</div>
							次
						</div>
					</div>
					<ServiceItem
						:item="item"
						:index="index"
						:type="'node'"
						:isShowDelete="isDelete"
						@nameEditClick="nameEditClick"
						@controlClick="controlClick"
						@openClick="openClick"
						@deleteClick="doDeleteClick"
						v-for="(item, index) in serviceList"
						v-bind:key="index"
					></ServiceItem>
				</div>
				<div class="delete-wrap">
					<div
						class="delete-btn"
						@click="deleteClick"
						v-if="!isDelete"
					>
						<div class="delete-icon"></div>
						删除服务
					</div>
					<div
						class="delete-btn finish-btn"
						@click="noDeleteClick"
						v-else
					>
						完成
					</div>
				</div>
				<div class="btns">
					<div class="btn" @click="goDiyClick">
						手动添加
						<div
							class="title-tips"
							v-if="!$store.getters.isAppstoreMode"
						>
							限时免费
						</div>
					</div>
					<div class="btn btn2" @click="findClick">发现服务</div>
				</div>

				<Control
					:dev="device"
					:item="controlItem"
					:type="controlType"
					:isVipServer="true"
					@closeClick="hideControl"
					v-if="isShowControl && controlItem"
				></Control>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import async from "async";
import Nav from "@/components/Common/Nav.vue";
import HomeNav from "@/components/Common/HomeNav.vue";
import ServiceItem from "@/components/vip/ServiceItem.vue";
import Control from "@/components/remote/Control.vue";
export default {
	components: {
		Nav,
		HomeNav,
		ServiceItem,
		Control,
	},
	data: function () {
		return {
			allServiceCount: 0,
			isShowUse: true,
			isLoading: false,
			list: [],
			serviceList: [],
			isDelete: false,
			device: {}, // 选择设备信息
			isShowControl: false,
			controlItem: {},
			controlType: "",
			leftTimes: 0,
		};
	},
	watch: {
		"$store.state.user.leftTimes": function () {
			let _that = this;
			_that.leftTimes = _that.$store.state.user.leftTimes;
		},
		"$store.state.isLoadForBind": function () {
			this.getBindget();
		},
	},
	methods: {
		...mapActions([
			"vipLeft",
			"bindget",
			"nodelistmanset", //添加自定义服务
			"nodelist", //获取服务
			"nodelistmansetdel", //删除自定义服务
			"nodelistsetDel", //删除服务
			"nodeupdate", //修改服务名称
			"sendUserlog",
			"getServerTimes",
			"speclist",
		]),

		renderServiceTimes: function () {
			let _that = this;
			_that.getServerTimes([
				function (err, data) {
					_that.leftTimes =
						data && data.data && data.data.times
							? data.data.times
							: 0;
				},
			]);
		},

		goVipClick: function () {
			let _that = this;
			_that.$router.push("/home/vip");
		},

		doDeleteClick: function (data, index) {
			let _that = this;
			_that.sendUserlog(["service_remove", ""]);

			let pid = data.dev.peerid;
			let del = [];
			// console.log(data);
			if (data.dtype == 999 || !data.mac) {
				del = [{ Host: data.ip_str, Port: data.port }];
				_that.nodelistmansetdel([
					pid,
					del,
					function (err, data) {
						if (data && !data.rtn) {
							_that.serviceList.splice(index, 1);
							_that.allServiceCount = --_that.allServiceCount;
							_that.$forceUpdate();
						}
					},
				]);
			} else {
				// 支持端口删除
				del = [data.mac + "|" + data.port];
				_that.nodelistsetDel([
					pid,
					del,
					function (err, data) {
						if (data && !data.rtn) {
							_that.serviceList.splice(index, 1);
							_that.allServiceCount = --_that.allServiceCount;
							_that.$forceUpdate();
						}
					},
				]);
			}
		},
		noDeleteClick: function () {
			let _that = this;
			_that.isDelete = false;
		},
		deleteClick: function () {
			let _that = this;
			_that.isDelete = true;
		},

		goDiyClick: function () {
			let _that = this;
			_that.noDeleteClick();
			_that.$router.push("/home/vipmapping");
		},
		findClick: function () {
			let _that = this;
			_that.noDeleteClick();
			_that.$router.push({
				name: "VipSearch",
				params: { deviceList: _that.list },
			});
		},
		goClick: function () {
			let _that = this;
			_that.$router.push("/home/vipabout");
		},
		goNoVipClick: function () {
			let _that = this;
			_that.vipLeft([
				function () {
					if (_that.$store.state.user.vip_left <= 0) {
						_that.$router.back(-1);
						// _that.$router.push("/home/vipabout");
					}
				},
			]);
		},

		nameEditClick: function (item) {
			let _that = this;
			_that.nodeupdate([
				item.dev.peerid,
				item.mac,
				item.uname,
				function (err, data) {
					_that.sendUserlog(["serviceName_edit", ""]);
				},
			]);
		},

		controlClick: function (item) {
			let _that = this;
			// console.log("aaa", item);
			_that.controlItem = item;
			_that.controlType = "control";
			_that.device = item.dev;
			_that.showControl();
		},
		openClick: function (item) {
			let _that = this;
			_that.controlItem = item;
			_that.controlType = "wakeup";
			_that.device = item.dev;
			_that.showControl();
		},
		showControl: function () {
			this.isShowControl = true;
		},
		hideControl: function () {
			this.renderServiceTimes();
			this.isShowControl = false;
		},

		getBindget: function () {
			let _that = this;
			_that.isLoading = true;
			_that.bindget([
				function (err, data) {
					if (data && !data.rtn) {
						//rtn等于0时，后台不返回此字段
						if (data && data.terms && data.terms.length > 0) {
							_that.list = data.terms;

							_that.$store.state.user.isAllLenvNas = false;

							let lenvNasNum = 0;

							for (
								let index = 0;
								index < _that.list.length;
								index++
							) {
								const element = _that.list[index];
								let pidInfo = _that.$common.getInfoByPid(
									element.peerid
								);
								if (pidInfo.cid == 101 || pidInfo.cid == 123) {
									lenvNasNum++;
								}

								// 构造ip mac 信息
								element.ip = "";
								element.mac = "";

								if (element.term && !element.term.name) {
									element.term.name =
										pidInfo.cname + pidInfo.dname;
								}

								if (element.term && element.term.nic) {
									let nic = _that.$common.getNicByNics(
										element.term.nic
									);
									if (nic) {
										element.ip = nic.ipv4n;
										element.mac = nic.mac;
									}
								}
								if (element.term && element.term.comment) {
									if (element.term.comment == "0") {
										element.term.comment = "";
									}
								}
							}

							if (
								lenvNasNum == _that.list.length &&
								_that.list.length > 0
							) {
								_that.$store.state.user.isAllLenvNas = true;
							}

							//获取设备服务
							_that.renderServices();
						}
					}

					_that.sendUserlog(["bindget", JSON.stringify(data)]);
				},
			]);
		},
		renderServices: function () {
			let _that = this;
			_that.allServiceCount = 0;

			let services = [];
			//根据设备获取设备服务
			async.eachSeries(
				_that.list,
				function (item, cb) {
					//设备
					let dev = JSON.parse(JSON.stringify(item));
					_that.speclist([
						item.peerid,
						2,
						function (err, data) {
							//获取服务列表放到设备中
							item.serviceList = _that.buildServiceList(
								data,
								item
							);
							//遍历服务列表
							for (
								let index = 0;
								index < item.serviceList.length;
								index++
							) {
								const element = item.serviceList[index];
								//把设备放到服务中
								element.dev = dev;
								services.push(element);
								_that.allServiceCount++;
							}

							cb ? cb() : null;
						},
					]);
				},
				function () {
					_that.isLoading = false;
					_that.serviceList = services;

					let device_service_off_num = 0;
					let device_service_on_num = 0;

					for (let index = 0; index < services.length; index++) {
						let element = services[index];
						if (element.status == 1) {
							device_service_off_num++;
						} else {
							device_service_on_num++;
						}
					}
					_that.$store.state.user.vip_service_off_num =
						device_service_off_num;
					_that.$store.state.user.vip_service_on_num =
						device_service_on_num;

					_that.$store.state.user.vip_service_num =
						_that.serviceList.length;
					//渲染数据
					_that.$forceUpdate();
				}
			);
		},
		buildServiceList: function (data, dev) {
			let _that = this;
			let serviceList = [];
			let pidInfo = _that.$common.getInfoByPid(dev.peerid);
			if (data && !data.rtn && data.jd) {
				//当一个服务有多个端口时，需要展示多个端口
				for (let i = 0; i < data.jd.length; i++) {
					let svs = data.jd[i].svs;
					let item = data.jd[i];
					if (item.dtype) {
						//不显示没有类型的服务
						if (svs) {
							if (svs.length > 0) {
								//有多个端口需要进行拆分
								for (let j = 0; j < svs.length; j++) {
									let item = JSON.parse(
										JSON.stringify(data.jd[i])
									);
									item.ports = [svs[j].port];
									item.port = svs[j].port;
									item.port_name = svs[j].name
										? svs[j].name
										: "";
									item.rule = svs[j].rule ? svs[j].rule : 0;
									item.icon = svs[j].icon ? svs[j].icon : 0;
									item.button = svs[j].button
										? svs[j].button
										: "";
									// for test
									// item.icon = "";
									serviceList.push(item);
								}
							}
						} else {
							//没有端口
							if (item.status == 1) {
								//仅添加离线的能够开机的设备
								serviceList.push(data.jd[i]);
							}
						}
					}
				}

				_that.rebuildList(serviceList, dev);
			}
			//  else if (pidInfo.cid == 99) {
			// 	//cid是99的设备
			// 	serviceList.push({
			// 		dtype: 3,
			// 		port: 3389,
			// 		ports: [3389],
			// 		ip: 16777343,
			// 		status: 0,
			// 	});
			// 	_that.rebuildList(serviceList, dev);
			// }
			return serviceList;
		},
		rebuildList: function (list, dev) {
			let _that = this;

			// let nasWebPort =
			// 	dev.term && dev.term.nasWebPort ? dev.term.nasWebPort : "";

			_that.$common.rebuildServerItems(
				list,
				_that.$store.state.nasExPorts
			);

			for (let index = list.length - 1; index >= 0; index--) {
				const element = list[index];
				// 联想渠道隐藏nas设备
				if (
					element.dtype == 1 &&
					_that.$store.state.user.isAllLenvNas
				) {
					list.splice(index, 1);
				} else if (element.dtype == 1 && element.port == 80) {
					// nas过滤80
					list.splice(index, 1);
				} else if (element.dtype == 2 && element.port != 80) {
					// 遍历删除路由器设备非80端口
					list.splice(index, 1);
				}
				// else if (
				// 	element.dtype == 3 &&
				// 	element.port != 3389 &&
				// 	!element.status
				// ) {
				// 	// 遍历删除在线电脑设备非3389端口
				// 	list.splice(index, 1);
				// }
				//  else if (
				// 	element.dtype == 1 &&
				// 	element.port != 5000 &&
				// 	element.port != 8080 &&
				// 	!_that.$store.state.nasExPorts.includes(element.port)
				// ) {
				// 	// 遍历删除NAS设备非5000或者非8080端口
				// 	if (nasWebPort) {
				// 		// 考虑有nasWebPort的情况
				// 		if (
				// 			element.port == nasWebPort &&
				// 			element.mac == dev.mac
				// 		) {
				// 			element.btn = "NAS管理";
				// 			let pidInfo = _that.$common.getInfoByPid(
				// 				dev.peerid
				// 			);
				// 			// 铁威马设备管理端口默认rule=1
				// 			if (pidInfo.cid == 108) {
				// 				element.rule = 1;
				// 			}
				// 		} else {
				// 			list.splice(index, 1);
				// 		}
				// 	} else {
				// 		list.splice(index, 1);
				// 	}
				// }
			}

			// 按ip排序
			list.sort(function (a, b) {
				return a.ip_num - b.ip_num;
			});
		},
	},
	activated() {
		let _that = this;
		_that.getBindget();
		_that.renderServiceTimes();
		// _that.goNoVipClick();
	},
};
</script>

<style lang="less" scoped>
.viplist-wrap {
	background-color: #f2f5fa;
	width: 960px;
	height: 426px;
	overflow: hidden;
}
.viplist {
	margin: 0 auto;
	width: 940px;
	height: 418px;
	box-sizing: border-box;
	border-radius: 4px;
	// background-image: url("../assets/vip/bg.png");
	background-image: url(../assets/setting/bg.png);
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-color: #ffffff;
	border: 1px solid #e8c29b;
	border-top: none;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	overflow: hidden;
	.no-service-wrap {
		position: relative;
		padding-top: 1px;
		width: 932px;
		height: 469px;
		box-sizing: border-box;
		.how-to-use {
			position: absolute;
			left: 50%;
			top: -2px;
			margin-left: 1px;
			transform: translate(-50%, 0);
			width: 916px;
			height: 84px;
			background-image: url("../assets/vip/howToUse.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			.close {
				position: absolute;
				top: 10px;
				right: 18px;
				width: 21px;
				height: 21px;
				cursor: pointer;
				background-image: url("../assets/vip/close.svg");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
			.diamond-icon {
				display: inline-block;
				margin-left: 73px;
				margin-top: 14px;
				vertical-align: top;
				width: 58px;
				height: 53px;
				background-image: url("../assets/vip/diamond.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
			.diamond-wrap {
				display: inline-block;
				margin-left: 6px;
				margin-top: 17px;
				vertical-align: top;
				.diamond-text {
					font-weight: 600;
					font-size: 14px;
					line-height: 19px;
					color: #95551b;
				}
				.diamond-btn {
					padding-left: 5px;
					margin-top: 7px;
					width: 82px;
					height: 24px;
					line-height: 24px;
					color: #95551b;
					font-size: 12px;
					border: 1px solid #95551b;
					border-radius: 20px;
					text-align: center;
					box-sizing: border-box;
					cursor: pointer;
					.diamond-btn-icon {
						display: inline-block;
						margin-top: 3px;
						vertical-align: top;
						width: 17px;
						height: 17px;
						background-image: url("../assets/vip/diamond2.svg");
						background-repeat: no-repeat;
						background-size: 100% 100%;
					}
				}
			}
		}
		.no-service {
			margin-top: 120px;
			text-align: center;
			.no-icon {
				margin: 0 auto;
				width: 90px;
				height: 85px;
				background-image: url("../assets/vip/noService.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
			.no-text {
				margin-top: 29px;
				font-weight: 600;
				font-size: 14px;
				line-height: 18px;
				color: #1f1f1f;
			}
			.no-text2 {
				margin-top: 3px;
				font-size: 14px;
				line-height: 18px;
				color: #666666;
			}
		}
		.btns {
			margin-top: 75px;
			text-align: center;
			.btn {
				display: inline-block;
				vertical-align: top;
				width: 156px;
				height: 42px;
				line-height: 42px;
				font-weight: 700;
				font-size: 16px;
				color: #ffffff;
				background: linear-gradient(156deg, #2f4386 26%, #1b3065 82%);
				box-shadow: 0px 3px 7px rgba(43, 48, 57, 0.1);
				border-radius: 200px;
				cursor: pointer;
				position: relative;
			}
			.btn:hover {
				opacity: 0.9;
			}
			.btn2 {
				margin-left: 24px;
			}
		}
	}
	.service-wrap {
		margin: 0 auto;
		margin-left: 8px;
		margin-top: 8px;
		width: 923px;
		height: 330px;
		box-sizing: border-box;
		overflow-y: scroll;
	}
	.delete-wrap {
		position: relative;
		margin-left: 20px;
		margin-top: 15px;
		width: 112px;
		height: 42px;
		.delete-btn {
			position: absolute;
			left: 0;
			top: 0;
			width: 112px;
			height: 42px;
			line-height: 42px;
			border-radius: 120px;
			color: #666666;
			cursor: pointer;
			text-align: center;
			box-sizing: border-box;
			.delete-icon {
				display: inline-block;
				margin-top: 10px;
				margin-right: 4px;
				vertical-align: top;
				width: 20px;
				height: 20px;
				background-image: url("../assets/vip/delete.svg");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
		}
		.delete-btn:hover {
			background-color: #d6d8da;
		}
		.finish-btn {
			color: #243a5d;
			border: 1px solid #243a5d;
			font-weight: 700;
			font-size: 14px;
		}
		.finish-btn:hover {
			background-color: transparent;
		}
	}
	.btns {
		margin-top: -40px;
		text-align: center;
		.btn {
			display: inline-block;
			vertical-align: top;
			width: 156px;
			height: 42px;
			line-height: 42px;
			font-weight: 700;
			font-size: 16px;
			color: #ffffff;
			background: linear-gradient(156deg, #2f4386 26%, #1b3065 82%);
			box-shadow: 0px 3px 7px rgba(43, 48, 57, 0.1);
			border-radius: 200px;
			cursor: pointer;
			position: relative;

			.title-tips {
				background: #ff4343;
				border-radius: 12px 4px;
				position: absolute;
				right: -10px;
				top: -10px;
				font-weight: normal;
				color: #ffffff;
				padding: 3px 10px;
				line-height: 14px;
				font-size: 12px;
			}
		}
		.btn:hover {
			opacity: 0.9;
		}
		.btn2 {
			margin-left: 24px;
		}
	}
}

.about-vip {
	position: relative;
	margin: 0 auto;
	width: 904px;
	height: 48px;
	background-image: url("../assets/remote/aboutVip.png");
	background-repeat: no-repeat;
	background-size: 100% 100%;
	box-shadow: 0px 2px 4px 0px rgba(200, 189, 161, 0.4);
	border-radius: 4px;
	.vip-icon,
	.vip-icon2,
	.vip-text {
		display: inline-block;
		vertical-align: top;
	}
	.vip-icon {
		margin-left: 21px;
		width: 44px;
		height: 44px;
		background-image: url("../assets/remote/aboutVip3.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	.vip-icon2 {
		margin-top: 13px;
		width: 55px;
		height: 21px;
		background-image: url("../assets/remote/aboutVip2.svg");
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	.vip-text {
		margin-left: 4px;
		margin-top: 15px;
		font-size: 12px;
		line-height: 18px;
		color: #5b3d15;
	}
	.vip-btn {
		position: absolute;
		right: 24px;
		top: 10px;
		width: 80px;
		height: 28px;
		background: linear-gradient(270deg, #724007 2%, #9f6f21 94%);
		box-shadow: 0px 2px 3px rgba(97, 59, 14, 0.1);
		border-radius: 20px;
		font-size: 12px;
		color: #eeddc7;
		text-align: center;
		line-height: 28px;
		cursor: pointer;
	}
}
.try-times {
	position: relative;
	padding-top: 1px;
	margin: 0 auto;
	margin-top: 12px;
	width: 902px;
	height: 28px;
	box-sizing: border-box;
	text-align: center;

	.line {
		margin-top: 13px;
		width: 100%;
		height: 1px;
		background-color: rgba(153, 153, 153, 0.5);
	}
	.try-text {
		position: relative;
		display: inline-block;
		vertical-align: top;
		line-height: 28px;
		width: 150px;
		color: #666666;
		font-size: 14px;
		.try-count {
			display: inline-block;
			margin-left: 4px;
			margin-right: 4px;
			vertical-align: top;
			font-weight: 600;
			font-size: 20px;
			color: #ee362b;
		}
	}
	.try-text::before {
		position: absolute;
		top: 50%;
		left: -190px;
		transform: translate(-50%, 0);
		content: "";
		width: 372px;
		height: 1px;
		background-color: rgba(153, 153, 153, 0.5);
	}
	.try-text::after {
		position: absolute;
		top: 50%;
		left: 340px;
		transform: translate(-50%, 0);
		content: "";
		width: 372px;
		height: 1px;
		background-color: rgba(153, 153, 153, 0.5);
	}
}
</style>